import { UserType } from "../api"

import UsersListPage from "./UsersListPage"

export default function ContentOnlyUsersPage() {
  return (
    <UsersListPage
      userType={UserType.CONTENT_ONLY}
      title="Content-Only Users"
      description="Users with access to content only — they cannot purchase lab tests or receive clinical services. User type is set automatically based on purchased package, or manually by admins via the user detail page."
      csvPrefix="content-only-users"
    />
  )
}
